function newsTop(){
	let news_length = $('.section--top--mainvisual__news__ul').find('li').length;
	$('.section--top--mainvisual__news__ul').css('width', 360 * news_length);
	let count = 1;
	$('.section--top--mainvisual__news .number').html(count + '/' + news_length);

	$(document).on('click', '.section--top--mainvisual__news .btn li a',function(e){
		e.preventDefault();
		if($(this).parent().hasClass('prev') && count > 1){
			var n = 360 * (count-1) - 360;
			$('.section--top--mainvisual__news__ul').css('transform', 'translateX(-' + n + 'px)');
			count--;
			$('.section--top--mainvisual__news .number').html(count + '/' + news_length);
		}else if($(this).parent().hasClass('next') && count < news_length){
			count++;
			var n = 360 * (count-1);
			$('.section--top--mainvisual__news__ul').css('transform', 'translateX(-' + n + 'px)');
			$('.section--top--mainvisual__news .number').html(count + '/' + news_length);
		}else if(count = news_length){
			count = 0;
		}
	});
}

module.exports = newsTop;



// WEBPACK FOOTER //
// ./es2015/_top_news.js